import React from 'react'
import Home_Hero_Two from '../../images/videos/Tattva Realty Dubai Promo.mp4'
import Home_Hero_Two_Tablet from '../../images/videos/Tattva Realty Dubai Promo (Tab Version).mp4'
import Home_Hero_Two_Mobile from '../../images/videos/Tattva Realty Dubai Promo (Mobile Version).mp4'
import { useEffect, useState } from 'react';
import '.././Location.css'
import '.././Home.css'
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import Home_Project_One from '../../images/azizi-venice.jpg';
import Home_Project_Two from '../../images/reportage-village.jpg';
import Home_Project_Three from '../../images/damooc-lagons.jpg';
import DiscussForm from '../../components/DiscussForm';



function Dubai() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on page load
    }, []);
    return (
        <div className='location-main'>

            {/* Hyderbad Hero */}
            <div className='about-hero hyd-hero'>
                <div className='about-hero-inner d-flex justify-content-center align-items-center'>
                    <div>
                        <h1 className='syne-title'>Dubai<span className='text-rose'>.</span></h1>
                        <p className='text-center'>Home / Locations / <span className='text-rose'>Dubai</span></p>
                    </div>
                </div>
            </div>
            {/* Hyderbad Hero */}
            {/* Hyderbad Video */}
            <div className='hyd-main'>
                <video src={Home_Hero_Two} autoPlay loop muted className='video-full d-lg-block d-none'></video>
                <video src={Home_Hero_Two_Tablet} autoPlay loop muted className='video-full d-md-block d-lg-none d-none '></video>
                <video src={Home_Hero_Two_Mobile} autoPlay loop muted className='video-full d-block d-md-none '></video>
            </div>
            {/* Hyderbad Video */}
            {/* Home Projects */}
            <div className='home-landowner container-fluid py-4'>
                <div className='home-landowner-inner container py-4'>
                    <h1 className='syne-title text-center mb-3'>Our Projects<span className='text-rose'>.</span></h1>
                    <p className='mb-4 text-secondary'>Our Project Partnership offers property owners a unique chance to collaborate with Tattva Hi Life in lucrative real estate developments. By partnering with us, owners can leverage their land to secure a substantial share in project profits without the complexities of construction management. With our expert guidance and commitment to transparency, we help property owners maximize their returns while they retain control over their valuable assets.</p>
                    <div className='home-land-cards'>
                        <div className='row'>
                            <div className='col-lg-4 col-md-6 my-3'>
                                <div className='home-land-card h-100 shadow-sm'>
                                    <img src={Home_Project_One} className='img-fluid home-land-card-img' />
                                    <div className='home-land-card-content p-3 text-center bg-white'>
                                        <h4 className='fw-bold'>Azizi Venice</h4>
                                        <p className='mb-1'>Dubai, UAE</p>
                                        <div className='home-about-btn text-center'>
                                            <Link to="/project-azizi" className="text-rose"><FaLongArrowAltRight /> Know More</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 col-md-6 my-3'>
                                <div className='home-land-card h-100 shadow-sm'>
                                    <img src={Home_Project_Two} className='img-fluid home-land-card-img' />
                                    <div className='home-land-card-content p-3 text-center bg-white'>
                                        <h4 className='fw-bold'>Reportage Village</h4>
                                        <p className='mb-1'>Dubai, UAE</p>
                                        <div className='home-about-btn text-center'>
                                            <Link to="/project-reportage" className="text-rose"><FaLongArrowAltRight /> Know More</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 col-md-6 my-3'>
                                <div className='home-land-card h-100 shadow-sm'>
                                    <img src={Home_Project_Three} className='img-fluid home-land-card-img' />
                                    <div className='home-land-card-content p-3 text-center bg-white'>
                                        <h4 className='fw-bold'>Damac Lagoons</h4>
                                        <p className='mb-1'>Dubai, UAE</p>
                                        <div className='home-about-btn text-center'>
                                            <Link to="/project-damac" className="text-rose"><FaLongArrowAltRight /> Know More</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Home Projects */}
            <DiscussForm />

        </div>
    )
}

export default Dubai

// //////////////////////////
// import React, { useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import DiscussForm from '../../components/DiscussForm';
// import projects from '../../data/ProjectsData';
// import { FaLongArrowAltRight } from "react-icons/fa";
// import '../Location.css';
// import '../Home.css';

// function Dubai() {
//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     const filteredProjects = projects.filter(
//         (project) => project.location?.toLowerCase() === 'dubai'
//     );

//     return (
//         <div className='location-main'>
//             {/* Dubai Hero */}
//             <div className='about-hero hyd-hero'>
//                 <div className='about-hero-inner d-flex justify-content-center align-items-center'>
//                     <div>
//                         <h1 className='syne-title'>Dubai<span className='text-rose'>.</span></h1>
//                         <p className='text-center'>
//                             <Link to="/" className="text-dark text-decoration-none">Home</Link> /{' '}
//                             <Link to="/projects" className="text-dark text-decoration-none">Locations</Link> /{' '}
//                             <span className='text-rose'>Dubai</span>
//                         </p>
//                     </div>
//                 </div>
//             </div>

//             {/* Dubai Projects */}
//             <div className='container-fluid py-4'>
//                 <div className='container py-4'>
//                     <div className="row">
//                         {filteredProjects.length > 0 ? (
//                             filteredProjects.map((project) => (
//                                 <div className="col-lg-4 col-md-6 my-3" key={project.id}>
//                                     <div className="home-land-card h-100 shadow-sm">
//                                         <img src={project.image} className="img-fluid home-land-card-img" alt={project.title} />
//                                         <div className="home-land-card-content p-3 text-center bg-white">
//                                             <h6 className="fw-bold">{project.title}</h6>
//                                             <p className="mb-1">{project.location}</p>
//                                             <div className="home-about-btn text-center">
//                                                 <Link to={`/projects/${project.id}`} className="text-rose">
//                                                     <FaLongArrowAltRight /> Know More
//                                                 </Link>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))
//                         ) : (
//                             <p className='text-center text-secondary'>No projects available in Dubai at the moment.</p>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Discuss Form */}
//             <DiscussForm />
//         </div>
//     );
// }

// export default Dubai;
